import React, { useState, useEffect } from 'react'
import { Layout, Button, Divider, Form, Switch, notification, Typography } from 'antd'
import Module from '../../../Components/Module'
import { useSelector, useDispatch } from 'react-redux'
import api from '../../../Services/api'

import settingsData from './data.json'

const { Title } = Typography

const UpdatersSettingsPage = () => {

  const [loading, setLoading] = useState(false)

  const settings = useSelector(state => state.Settings)
  const dispatch = useDispatch()

  const changeSettings = data => {
    dispatch({ type: 'CHANGE_SETTINGS_DATA', Settings: data })
  }

  const getData = async () => {
    api.get('/settings')
      .then(response => response.data)
      .then(changeSettings)
  }

  const getSetting = (name) => {
    let setting = settings.find(v => v.name === name)
    return setting ? setting.value : null
  }

  const handleChange = ({ name, value }) => {
    let x = settings.filter(v => v.name !== name)

    x.push({name, value})

    changeSettings(x)
  }

  const handleSubmit = () => {
    setLoading(true)

    settings.forEach(async ({ name, value }) => {
      if (!name) return
      try {
        await api.post('/setting', { name,value })
      } catch (e) {
        notification.error({ message: `Failed to save setting ${name} with value ${value}!` })
      }
    })

    notification.success({ message: 'Settings updated successfully!' })
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  const formLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 }
  }

  return (
    <Layout>
      <Module>
        <Button onClick={handleSubmit} loading={loading} type='primary'>Save settings</Button>
      </Module>
      <Module title={<Title level={4}>Bots status</Title>}>
        <Divider/>
        {settingsData.map((setting) => (
          <Module key={setting.label} bordered={true} title={<Title level={4}>{setting.label}</Title>}>
            <Form  {...formLayout}>
              {setting.settings.map(({label, name}) => (
                <Form.Item key={name} label={label}>
                  <Switch checked={getSetting(name)} onChange={(value) => handleChange({ name, value })}/>
                </Form.Item>
              ))}
            </Form>
          </Module>
        ))}
      </Module>
    </Layout>
  )
}

export default UpdatersSettingsPage